module.exports = __webpack_public_path__ + "static/media/nav-dashboard-logo.36ef266d.svg";